import './AvailabilityVisibility.scss';

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import dayjs from 'dayjs';

import { getDayAppointments, getDayUnavailability } from 'actions/appointments';
import Button from 'atoms/button';
import { DefaultAvatar } from 'atoms/default-avatar';
import Icon from 'atoms/icon';
import { isNotEmptyArray } from 'util';

const formatTime = (dateTime) => dayjs(dateTime).format('h:mma');

export default function AvailabilityVisibility({
  selectedDate,
  selectedGroomer,
  className,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [availabilityVisibility, setAvailabilityVisibility] = useState({
    appointments: [],
    unavailability: [],
  });
  const [hideVisibility, setHideVisibility] = useState(false);

  const date = selectedDate?.date;
  const groomer = selectedGroomer?.uuid;
  const { appointments, unavailability } = availabilityVisibility;
  const hasAvailabilityData =
    isNotEmptyArray(appointments) || isNotEmptyArray(unavailability);

  useEffect(() => {
    setAvailabilityVisibility({
      appointments: [],
      unavailability: [],
    });

    const fetchAvailabilityData = async () => {
      const appointments = await dispatch(
        getDayAppointments({ date, groomer })
      );
      const unavailability = await dispatch(
        getDayUnavailability({ date, groomer })
      );
      setAvailabilityVisibility({
        appointments: appointments || [],
        unavailability: unavailability || [],
      });
    };

    if (date && groomer) {
      fetchAvailabilityData();
    }
  }, [date, groomer]);

  return (
    hasAvailabilityData && (
      <div
        className={classNames(
          'availability-visibility flex-column align-start',
          className
        )}
      >
        {!hideVisibility && (
          <>
            {appointments.map((appointment) => {
              const { animal, service, dateStart, dateEnd, uuid } = appointment;
              const petDetails = [];
              if (animal.breed?.value) petDetails.push(animal.breed?.value);
              if (animal.size?.value) petDetails.push(animal.size?.value);
              return (
                <div
                  key={uuid}
                  className="flex-row mb-8 p-12 border-light-purple radius-12 w-100"
                >
                  <button
                    onClick={() => navigate(`/pet-profile/${animal?.uuid}`)}
                    className="no-style-btn pointer"
                  >
                    <DefaultAvatar
                      avatar={animal?.links?.image?.desktop?.small}
                      animal={animal}
                      size={16}
                    />
                  </button>
                  <div className="flex-column align-start ml-8">
                    <p className="f11 semibold">{`${
                      service?.name
                    } • ${formatTime(dateStart)} - ${formatTime(dateEnd)}`}</p>
                    <p className="f11 c-primary-purple">
                      {petDetails.join(' • ')}
                    </p>
                  </div>
                </div>
              );
            })}
            {unavailability.map((timeBlock) => {
              const { start, end, uuid } = timeBlock;
              return (
                <div
                  key={uuid}
                  className="flex-row mb-8 p-12 border-light-purple radius-12 w-100"
                >
                  <div className="unavailable-icon-container">
                    <Icon
                      name="close"
                      style={{
                        width: '11px',
                        height: '11px',
                        fill: '#63637b',
                      }}
                    />
                  </div>
                  <p className="f11 semibold ml-8">
                    {`Unavailable ${formatTime(start)} - ${formatTime(end)}`}
                  </p>
                </div>
              );
            })}
          </>
        )}
        <Button
          variant="link"
          onClick={() => setHideVisibility(!hideVisibility)}
          text={hideVisibility ? 'Show booked appointments' : 'Hide'}
          className="hide-button"
        />
      </div>
    )
  );
}
